(function () {
  'use strict';

  // Legacy attribute from an earlier version of this feature. We only ever
  // clear it (never write it) so any orphaned value from old carts gets
  // cleaned up the first time the user interacts with the new toggle.
  var LEGACY_GIFT_NOTE_KEY = 'Hediye Notu';

  var SELECTORS = {
    root: '[data-gift-wrap]',
    toggle: '[data-gift-wrap-toggle]',
    error: '[data-gift-wrap-error]',
  };

  var reconciling = false;

  function getRoot(el) {
    return el && el.closest ? el.closest(SELECTORS.root) : null;
  }

  function setLoading(root, loading) {
    if (!root) return;
    root.setAttribute('data-gift-wrap-loading', loading ? 'true' : 'false');
  }

  function showError(root, message) {
    if (!root) return;
    var errorEl = root.querySelector(SELECTORS.error);
    if (message) {
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'gw-row__error';
        errorEl.setAttribute('data-gift-wrap-error', '');
        root.appendChild(errorEl);
      }
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else if (errorEl) {
      // Remove the element entirely instead of just hiding it so its default
      // <p> margins cannot affect the row's vertical rhythm.
      errorEl.parentNode.removeChild(errorEl);
    }
  }

  function refreshCartDrawer() {
    document.dispatchEvent(
      new CustomEvent('theme:cart:refresh', { bubbles: true })
    );
  }

  function cartUpdate(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(
      function (r) {
        return r.json();
      }
    );
  }

  function countGiftWrap(cart, variantId) {
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === variantId || item.id === variantId) {
        qty = item.quantity;
      }
    });
    return qty;
  }

  function setGiftWrap(root) {
    if (!root) return Promise.resolve();
    var variantId = parseInt(root.getAttribute('data-gift-wrap-variant'), 10);
    if (!variantId) return Promise.resolve();

    showError(root, '');
    setLoading(root, true);

    var updates = {};
    updates[variantId] = 1;

    return cartUpdate({ updates: updates })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            var message =
              (err && err.description) ||
              'Üzgünüz, hediye paketi şu anda eklenemiyor.';
            var toggle = root.querySelector(SELECTORS.toggle);
            if (toggle) toggle.checked = false;
            showError(root, message);
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        refreshCartDrawer();
      })
      .catch(function () {
        /* showError already handled */
      })
      .finally(function () {
        setLoading(root, false);
      });
  }

  function removeGiftWrap(root) {
    if (!root) return Promise.resolve();
    var variantId = parseInt(root.getAttribute('data-gift-wrap-variant'), 10);
    if (!variantId) return Promise.resolve();

    showError(root, '');
    setLoading(root, true);

    var updates = {};
    updates[variantId] = 0;

    // Also clear the legacy custom gift-note attribute if any old cart still
    // has it. The theme's built-in gift notes widget uses a different
    // attribute key so this never touches user data written there.
    var attributes = {};
    attributes[LEGACY_GIFT_NOTE_KEY] = '';

    return cartUpdate({ updates: updates, attributes: attributes })
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject();
      })
      .then(function () {
        refreshCartDrawer();
      })
      .catch(function () {
        showError(root, 'Hediye paketi kaldırılırken bir hata oluştu.');
      })
      .finally(function () {
        setLoading(root, false);
      });
  }

  /**
   * Passive: reflect cart state into the UI.
   * Does NOT modify the cart. Single source of truth = server cart.
   */
  function syncUIFromCart(root, cart) {
    var variantId = parseInt(root.getAttribute('data-gift-wrap-variant'), 10);
    var gwInCart = countGiftWrap(cart, variantId);
    var hasGiftWrap = gwInCart > 0;

    root.setAttribute('data-gift-wrap-in-cart', String(gwInCart));

    var toggle = root.querySelector(SELECTORS.toggle);
    if (toggle && toggle.checked !== hasGiftWrap) {
      toggle.checked = hasGiftWrap;
    }

    if (!hasGiftWrap) showError(root, '');
  }

  /**
   * Active: enforce invariants that the UI cannot represent cleanly.
   */
  function enforceInvariants(root, cart) {
    var variantId = parseInt(root.getAttribute('data-gift-wrap-variant'), 10);
    var gwInCart = countGiftWrap(cart, variantId);
    var totalItems = cart.item_count || 0;

    // Case A: only gift wrap left in cart → nothing to wrap, remove it.
    if (gwInCart > 0 && totalItems === gwInCart) {
      return removeGiftWrap(root);
    }

    // Case B: more than one gift wrap (stale state) → force to 1.
    if (gwInCart > 1) {
      return setGiftWrap(root);
    }
  }

  function reconcile() {
    if (reconciling) return;
    var root = document.querySelector(SELECTORS.root);
    if (!root) return;

    reconciling = true;
    fetchCart()
      .then(function (cart) {
        syncUIFromCart(root, cart);
        enforceInvariants(root, cart);
      })
      .catch(function () {
        /* ignore */
      })
      .finally(function () {
        reconciling = false;
      });
  }

  function handleToggleChange(root, checked) {
    if (checked) {
      setGiftWrap(root);
    } else {
      removeGiftWrap(root);
    }
  }

  function init() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches(SELECTORS.toggle)) {
        handleToggleChange(getRoot(target), target.checked);
      }
    });

    document.addEventListener('theme:cart:loaded', reconcile);
    document.addEventListener('theme:cart:added', reconcile);

    if (document.readyState !== 'loading') {
      reconcile();
    } else {
      document.addEventListener('DOMContentLoaded', reconcile);
    }
  }

  init();
})();
